export const CLIENT = 'client';
export const INVOICES = 'invoices';
export const STAFF = 'staff';
export const DISPLAY = 'DISPLAY';
export const LANGUAGE = 'LANGUAGE';
